export default "__VITE_ASSET__Kzm4UjIgA1kMLjKeA0Qcvg__"